import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { PurchaseMenu } from "@website/widget/common/components/purchase-menu";
import { useMyTrips } from "@website/widget/header/components/my-trips/my-trips-hook";

export function MyTrips() {
  const {
    purchaseList,
    purchaseMenuIsOpen,
    onPurchaseMenuClose,
    onPurchaseMenuOpen
  } = useMyTrips();
  return (
    <div className="relative">
      <Button
        StartIcon={<MaterialIcon name="luggage" variant="outlined" />}
        className="!mx-0 max-xl:!hidden"
        color="neutral"
        onClick={onPurchaseMenuOpen}
        variant="text"
      >
        سفرهای من
      </Button>
      <Button
        EndIcon={<MaterialIcon name="luggage" variant="outlined" />}
        aria-label="Show Purchase List"
        className="!mx-0 xl:!hidden"
        color="neutral"
        equalDimension
        onClick={onPurchaseMenuOpen}
        variant="text"
      />
      <PurchaseMenu
        isOpen={purchaseMenuIsOpen}
        list={purchaseList}
        onClose={onPurchaseMenuClose}
      />
    </div>
  );
}
